import axios from 'axios';
import { removeCookie } from 'utils/cookies';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://dev.livrestofood.tn';

const baseHttp = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

let isRefreshing = false;
let refreshQueue = [];
let isRedirectingToLogin = false;

const clearClientSession = () => {
  removeCookie('_sid');
  removeCookie('authUser');
  removeCookie('authRestaurant');
};

const redirectToLogin = () => {
  if (isRedirectingToLogin) return;
  isRedirectingToLogin = true;
  clearClientSession();
  window.location.href = '/auth/sign-in';
};

const resolveRefreshQueue = (error = null) => {
  refreshQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve();
  });
  refreshQueue = [];
};

baseHttp.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;
    const status = err.response?.status;
    const errorMessage = err.response?.data?.error || '';
    const requestUrl = originalRequest?.url || '';
    const isRefreshRequest = requestUrl.includes('/api/v1/web/auth/refresh');
    const isLoginRequest = requestUrl.includes('/user/mobile/login/restaurant');
    const isMissingToken = status === 400 && errorMessage.includes('token is missing');
    const isAuthFailure = status === 401 || isMissingToken;

    if (!isAuthFailure || !originalRequest || originalRequest._retry || isRefreshRequest || isLoginRequest) {
      if (isAuthFailure && !isLoginRequest) redirectToLogin();
      return Promise.reject(err);
    }

    originalRequest._retry = true;

    if (isRefreshing) {
      try {
        await new Promise((resolve, reject) => {
          refreshQueue.push({ resolve, reject });
        });
        return baseHttp(originalRequest);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    isRefreshing = true;

    try {
      await axios.post(`${BASE_URL}/api/v1/web/auth/refresh`, {}, {
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' },
      });
      resolveRefreshQueue();
      return baseHttp(originalRequest);
    } catch (refreshError) {
      resolveRefreshQueue(refreshError);
      redirectToLogin();
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export default baseHttp;
